import React from 'react';

import { s } from '@functions/seo.ts';

import I from '../types.ts';

import AppButton from '../../appButton/AppButton.tsx';

const renderExecutorsBlock: I['renderExecutorsBlock'] = function () {
    const { pageName, device } = this.props;

    if (pageName !== 'executors') {
        return <></>;
    }

    return (
        <div className="publicTop__inner _row _top">
            <div className="publicTop__executorsFooter _row">
                <div className="publicTop__executorsFooterBlock _col">
                    <div className="publicTop__executorsFooterSupport">Скачать «Мой налог»</div>
                    <div className="publicTop__executorsFooterButtons _row">
                        <div className="publicTop__executorsFooterButton">
                            <AppButton name="apple" className="_reverse" />
                        </div>
                        <div className="publicTop__executorsFooterButton">
                            <AppButton name="google" className="_reverse" />
                        </div>
                        <div className="publicTop__executorsFooterButton">
                            <AppButton name="rustore" className="_reverse" />
                        </div>
                        <div className="publicTop__executorsFooterButton">
                            <AppButton name="appgalery" className="_reverse" />
                        </div>
                    </div>
                </div>
                <div className="publicTop__executorsFooterBlock _col _empty">
                    <div className="publicTop__executorsFooterSupport">Полезные ссылки</div>
                    <div className="publicTop__executorsFooterLinks _row">
                        <a
                            href="https://nalog.ru/"
                            rel="noreferrer"
                            target="_blank"
                            className="publicTop__executorsFooterLink"
                        >
                            Сайт ФНС России
                        </a>
                        <a
                            href="https://npd.nalog.ru/"
                            rel="noreferrer"
                            target="_blank"
                            className="publicTop__executorsFooterLink"
                        >
                            Сайт НПД
                        </a>
                        <a
                            href="https://npd.nalog.ru/faq/"
                            rel="noreferrer"
                            target="_blank"
                            className="publicTop__executorsFooterLink"
                        >
                            База знаний
                        </a>
                        <a
                            href="https://lknpd.nalog.ru/"
                            rel="noreferrer"
                            target="_blank"
                            className="publicTop__executorsFooterLink"
                        >
                            Личный кабинет НПД «Мои Налог»
                        </a>
                        <a
                            href="https://npd.nalog.ru/app/#howreglk"
                            rel="noreferrer"
                            target="_blank"
                            className="publicTop__executorsFooterLink"
                        >
                            Инструкция по постановке на учет для{' '}
                            {device === 'mobile' ? 'смз' : 'самозанятых'}
                        </a>
                    </div>
                </div>
                <div className="publicTop__executorsFooterBlock _col _partners">
                    <div className="publicTop__executorsFooterSupport">
                        Официальные партнеры платформы:
                    </div>
                    <div className="publicTop__executorsFooterLogos _row">
                        {!s() && (
                            <>
                                <img
                                    src={require('@img/crm/public/executors-fns-partner-logo-1.png')}
                                    alt=""
                                    className="publicTop__executorsFooterLogo"
                                />
                                <img
                                    src={require('@img/crm/public/executors-fns-partner-logo-2.png')}
                                    alt=""
                                    className="publicTop__executorsFooterLogo"
                                />
                                <img
                                    src={require('@img/crm/public/executors-fns-partner-logo-3.png')}
                                    alt=""
                                    className="publicTop__executorsFooterLogo"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default renderExecutorsBlock;
